import React, { Component } from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { ComboBox } from '@progress/kendo-react-dropdowns';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { getAllActiveProjectsAndCrs, updateProjectStartDate } from './ProjectService';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import Loader from '../../integration/components/Loader';
import SuccessImg from '../../ui/static/images/checked.svg';
import ErrorImg from '../../ui/static/images/cancel.svg';
import * as loggerService from "../../integration/LoggerService";
import {LOG_TYPES} from "../../integration/IntegrationEnums";
import moment from 'moment';

class AdminProjectStartDate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            projectsAndCrs: [],
            projectsAndCrsAll: [],
            selectedProjectOrCr: null,
            projectStartDate: null,
            selectedStartDate: null,
            isErrorMessageVisible: false,
            showMessageDialog: false,
            dialogMessage: '',
            dialogTitle: '',
            showErrorImage: false,
            showSuccessImage: false,
            loading: false,
        }
    }

    async componentDidMount() {
        this.isMount = true;
        window.scrollTo(0, 0);
        this.setHeaderTitle();
        await this.setState({
            loading: true,
        });
        await this.populateProjectAndCrs();
        await this.setState({
            loading: false,
        });
    }

    setHeaderTitle = async () => {
        if (this.isMount && this.props.onHeaderTitleChange) {
            this.props.onHeaderTitleChange('Update Project Start Date');
        }
    };

    populateProjectAndCrs = async () => {
        await getAllActiveProjectsAndCrs().then(res => {
            if (this.isMount) {
                this.setState({
                    projectsAndCrs: res.data,
                    projectsAndCrsAll: res.data
                });
            }
            })
            .catch(error => {
                loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
    };

    updateStartDate = async() => {
        if (!this.state.selectedProjectOrCr || !this.state.selectedStartDate) {
            this.setState({ isErrorMessageVisible: true });
            return;
        }

        await this.setState({
            loading: true,
        });

        const fields = {
            selectedProject: this.state.selectedProjectOrCr,
            selectedStartDate: moment(this.state.selectedStartDate).format('YYYY-MM-DD'),
        };        
        await updateProjectStartDate(fields)
            .then(res => {
                this.setState({
                    showSuccessImage: true,
                    showErrorImage: false,
                    selectedProjectOrCr: null,
                    selectedStartDate: null,
                    isErrorMessageVisible: false,
                });
                const message = "Project Start Date updated successfully.";
                const title = 'Success';
                this.toggleMessageDialog(message, title);
                })
            .catch(error => {
                loggerService.writeLog(error, LOG_TYPES.ERROR);
            });

        await this.setState({
            loading: false,
        });

    };

    onClickCancel = async() => {
        await this.setState({
            selectedProjectOrCr: null,
            selectedStartDate: null,
            isErrorMessageVisible: false,
        });
    };

    handleStartdateChange = event => {
        const valueObj = event.target.value;
        const field = event.target.name;
        if (this.isMount) {
            this.setState({
                [field]: valueObj
            });
        }
    };

    handleProjectOrCrChange = event => {
        const valueObj = event.target.value;
        const field = event.target.name;
        if (this.isMount) {
            this.setState({
                [field]: valueObj
            });
        }
    };

    toggleMessageDialog = (message, title) => {
        this.setState({
            showMessageDialog: !this.state.showMessageDialog,
            dialogMessage: message,
            dialogTitle: title
        });
    };

    filterProjectsAndCrs = event => {
        if (this.isMount) {
            this.setState({
                projectsAndCrs: this.filterData(event.filter, this.state.projectsAndCrsAll)
            });
        }
    };

    filterData(filter, allData) {
        const data = allData.slice();
        return filterBy(data, filter);
    }

    validateProperty = value => {
        if (value) {
            return 'd-none';
        } else {
            return 'inline-error';
        }
    };

    render() {
        return (
            <div className="main-card">
                <div className="row">
                    <div className="col-md-9">
                        <div className="main-heading">Update Project Start Date</div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4">
                        <div className="d-block">
                            <label>Project/CR Name:</label>
                        </div>
                        <div>
                            <ComboBox
                                placeholder="Please Select"
                                data={this.state.projectsAndCrs}
                                value={this.state.selectedProjectOrCr}
                                textField="DisplayName"
                                dataItemKey="id"
                                onChange={this.handleProjectOrCrChange}
                                name="selectedProjectOrCr"
                                filterable={true}
                                onFilterChange={this.filterProjectsAndCrs}
                            />
                            {this.state.isErrorMessageVisible === true ? (
                                <span className={this.validateProperty(this.state.selectedProjectOrCr)}>
                                    Please select a Project/CR
                                </span>
                            ) : null}
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4">
                        <div className="d-block">
                            <label>New Start Date:</label>
                        </div>
                        <div>
                           <DatePicker
                                width="100"
                                name="selectedStartDate"
                                onChange={this.handleStartdateChange}
                                value={this.state.selectedStartDate}
                                format="MM/dd/yyyy"
                                formatPlaceholder={{ year: 'YYYY', month: 'MM', day: 'DD' }}
                                max={new Date()}
                            />
                            {this.state.isErrorMessageVisible === true ? (
                                <span className={this.validateProperty(this.state.selectedStartDate)}>
                                    Please select a Date
                                </span>
                            ) : null}
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12" style={{ textAlign: 'right' }}>
                        <Button type="button" onClick={this.onClickCancel} style={{ marginRight: '5px' }}>
                            Clear
                        </Button>
                        <Button primary={true} type="submit" onClick={this.updateStartDate}>
                            Update
                        </Button>
                    </div>
                </div>

                {this.state.showMessageDialog === true && (
                    <Dialog title={this.state.dialogTitle} onClose={this.toggleMessageDialog} width="400px">
                        {this.state.showSuccessImage === true && (
                            <div className="text-center">
                            <img className="successImg" src={SuccessImg} alt="Success"/>
                            </div>
                        )}
            
                        {this.state.showErrorImage === true && (
                            <div className="text-center">
                            <img className="successImg" src={ErrorImg} alt="Error Image"/>
                            </div>
                        )}
            
                        <p style={{ margin: '25px', textAlign: 'center' }}>{this.state.dialogMessage}</p>
                        <DialogActionsBar>
                            <button className="k-button modal-primary" onClick={this.toggleMessageDialog}>
                                OK
                            </button>
                        </DialogActionsBar>
                    </Dialog>
                )}

                <Loader loading={this.state.loading} />
            </div>
        );
    }
}

export default AdminProjectStartDate;